import { Icon, IconProps } from '@chakra-ui/react'

export function RocketIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M5.18994 27.4551C4.85293 27.4551 4.54963 27.1858 4.54963 26.8155C4.54963 26.2095 4.61703 25.1659 4.81923 23.9876L2.99938 22.136C0.337009 25.2669 0.0337009 29.7444 0 31.3603C0 31.697 0.269607 32 0.640317 32C2.25796 31.9663 6.74018 31.6633 9.87437 29.0037L8.02082 27.1858C6.84129 27.3878 5.79656 27.4215 5.18994 27.4551Z"
        fill="currentColor"
      />
      <path
        d="M24.8713 20.4527L24.8039 20.2844C32.3529 12.3057 32.2181 4.05766 31.8811 1.26343C31.8137 0.657448 31.3419 0.186131 30.7352 0.118801C27.9381 -0.217854 19.6813 -0.352516 11.6942 7.18855L11.5594 7.15488C8.93074 5.94293 5.86396 6.51524 3.8082 8.53517L0.876223 11.4641C0.202204 12.1374 0.40441 13.2483 1.24693 13.6187L5.99876 15.8069L4.38112 18.3655C4.01041 18.9715 4.07781 19.7794 4.61702 20.3181L11.6942 27.3878C12.1997 27.8928 13.0086 27.9938 13.6489 27.6235L16.2101 26.0075L18.4007 30.7544C18.8051 31.596 19.9172 31.798 20.5576 31.1247L23.4895 28.1958C25.5453 26.1422 26.0845 23.045 24.8713 20.4527ZM18.1648 13.8543C16.7494 12.4404 16.7494 10.1848 18.1648 8.77083C19.5802 7.35688 21.8382 7.35688 23.2536 8.77083C24.6691 10.1848 24.6354 12.4404 23.2536 13.8543C21.8719 15.2346 19.5802 15.2346 18.1648 13.8543Z"
        fill="currentColor"
      />
    </Icon>
  )
}
